module.exports = __webpack_public_path__ + "img/banner-inter.2da845e0.jpg";